import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function readUtm() {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  UTM_KEYS.forEach((key) => {
    const val = params.get(key);
    if (val) utm[key.replace('utm_', '')] = val;
  });
  return utm;
}

function inferSource(referrer, utm) {
  if (utm.source) return utm.source;
  if (!referrer) return 'direct';
  try {
    const host = new URL(referrer).hostname.replace(/^www\./, '');
    if (/facebook|fb\.com|instagram|twitter|x\.com|tiktok|linkedin|youtube|whatsapp|telegram/i.test(host)) {
      return host;
    }
    if (host.includes('google')) return 'google';
    if (host.includes('bing')) return 'bing';
    return host;
  } catch {
    return 'unknown';
  }
}

/** Record a marketing-site visit with referrer + UTM + geo (when available). */
export async function trackSiteVisit(pagePath = '/') {
  if (typeof window === 'undefined') return null;

  const utm = readUtm();
  const referrer = document.referrer || '';
  const payload = {
    pagePath,
    referrer,
    source: inferSource(referrer, utm),
    medium: utm.medium || (referrer ? 'referral' : 'direct'),
    campaign: utm.campaign || '',
    userAgent: navigator.userAgent?.slice(0, 240) || '',
    language: navigator.language || '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    createdAt: serverTimestamp(),
  };

  try {
    const geoRes = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(4000) });
    if (geoRes.ok) {
      const geo = await geoRes.json();
      payload.country = geo.country_name || geo.country || '';
      payload.countryCode = geo.country_code || '';
      payload.city = geo.city || '';
      payload.region = geo.region || '';
      payload.ip = geo.ip || '';
    }
  } catch {
    /* geo optional */
  }

  try {
    return await addDoc(collection(db, 'siteVisits'), payload);
  } catch (err) {
    console.warn('Visit tracking failed:', err);
    return null;
  }
}
